<template>
  <div class="offered">
    <div class="offered-title">
      <back-button
        :text="$t('components.offered.button.back')"
        @click="goTohome()"
      />
      <span class="page">{{ $t('components.offered.title') }}</span>
      <cart-button />
    </div>
    <card-offered
      :offered="offered"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import CardOffered from '@/components/cards/offered/CardOffered.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import CartButton from '@/components/buttons/CartButton.vue';

export default {
  name: 'TargetedOffered',
  components: {
    CardOffered,
    BackButton,
    CartButton,
  },
  data() {
    return {
      itemsCart: 0,
    };
  },
  computed: {
    ...mapGetters({
      offered: 'getCreditOffered',
    }),
  },
  beforeMount() {
    this.initLoading();
    this.fetchTargetedCreditOffered(this.$route.params.token);
  },
  methods: {
    ...mapActions([
      'fetchTargetedCreditOffered',
      'initLoading',
    ]),

    goTohome() {
      this.$router.push({ name: 'home' });
    },
  },
};
</script>
<style lang="scss" scoped>
.offered {
  background: $dashboard_background;
  min-height: 100vh;
  display: flex;
  padding: 40px 40px 0px 270px;
  flex-direction: column;

  .offered-title {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 50px;

    .page {
      font-size: 1.5em;
      font-weight: bold;
    }
  }
}
</style>
